<template>
  <div id="menu-my-account" role="tabpanel" class="tab-pane show" aria-labelledby="my-account-tab">
    <div class="submenu-nav-header">
      <div class="my-1 d-lg-none"></div>
      <h4 class="mb-0">My Account</h4>
      <small class="mb-1"><i>Manage your account and all information related to it</i></small>
    </div>
    <div class="tab-content">
      <hr class="mt-2">
      <div id="sm-my-account" role="tabpanel" class="tab-pane active">
        <div class="row">
          <div class="col-md-6 col-xl-3">
            <router-link tag="div"
                         class="submenu-nav-item"
                         active-class="active"
                         :to="menu.myAccount.routerTo"
                         @click.native="setMenuState()">
              <div class="submenu-nav-icon">
                <fa-icon :icon="menu.myAccount.icon" :class="menu.myAccount.iconClass + ' fa-3x'"/>
              </div>
              <div class="submenu-nav-content">
                <p class="submenu-nav-item-title">{{ menu.myAccount.title }}</p>
                <p class="submenu-nav-item-details">{{ menu.myAccount.details }}</p>
              </div>
            </router-link>
          </div>
        </div>
        <div class="row">
          <div v-if="security.canCreate('users')" class="col-md-6 col-xl-3">
            <router-link tag="div"
                         class="submenu-nav-item"
                         active-class="active"
                         :to="menu.myAccountRegister.routerTo"
                         @click.native="setMenuState()">
              <div class="submenu-nav-icon">
                <fa-icon :icon="menu.myAccountRegister.icon" :class="menu.myAccountRegister.iconClass + ' fa-3x'"/>
              </div>
              <div class="submenu-nav-content">
                <p class="submenu-nav-item-title">{{ menu.myAccountRegister.title }}</p>
                <p class="submenu-nav-item-details">{{ menu.myAccountRegister.details }}</p>
              </div>
            </router-link>
          </div>
          <div class="col-md-6 col-xl-3">
            <router-link tag="div"
                         class="submenu-nav-item"
                         active-class="active"
                         :to="menu.myAccountFindUser.routerTo"
                         @click.native="setMenuState()">
              <div class="submenu-nav-icon">
                <fa-icon :icon="menu.myAccountFindUser.icon" :class="menu.myAccountFindUser.iconClass + ' fa-3x'"/>
              </div>
              <div class="submenu-nav-content">
                <p class="submenu-nav-item-title">{{ menu.myAccountFindUser.title }}</p>
                <p class="submenu-nav-item-details">{{ menu.myAccountFindUser.details }}</p>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import menuItems from '@/common/menu'

import {
  NAV_GET_MENU_OPEN,
  NAV_SET_MENU_OPEN
} from '@/store/navigation/nav.types'

export default {
  data () {
    return {
      menu: menuItems
    }
  },

  methods: {
    setMenuState () {
      this.$store.commit(NAV_SET_MENU_OPEN, !this.getMenuState())
    },

    getMenuState () {
      return this.$store.getters[NAV_GET_MENU_OPEN]
    }
  },

  components: {
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/views/navigation/NavMenuMyAccount.vue